<template>
  <div class="c-towers-graph">
    <div class="title">{{ title }}</div>
    <div class="graph-body">
      <div class="towers-place" :class="{'transform': transform}">
        <div v-for="(item, index) in rTowers" :key="index" :style="{'background-color': item.background}" class="tower">
          <div class="fill" :style="{'background-color': item.color, 'top': (100 - (Math.min(item.value / item.maxValue, 1))* 100)+'%'}" />
          <div class="number" :style="{'bottom': 'calc('+((Math.min(item.value / item.maxValue, 1))* 100)+'% + 15px)'}">
            {{ formatPrice(item.value) + '₸' }}
          </div>
        </div>
      </div>
      <div v-show="showMemo" class="memos">
        <div v-for="(item, index) in towers" :key="index" class="memo">
          <div class="box" :style="{'background-color': item.color,}" />
          <div class="title">{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CTowersGraph',
  props: {
    title: {
      type: String,
      default: 'Общие данные',
    },
    towers: {
      type: Array,
      required: true,
    },
    showMemo: {
      type: Boolean, default: true,
    },
    transform: {
      type: Boolean, default: false,
    },
  },
  data() {
    return {
      rTowers: this.towers,
    }
  },
  watch: {
    towers() {
      this.animate()
    },
  },
  methods: {
    async animate() {
      this.rTowers = $n.map(this.towers, (t) => {
        return { ...t, value: 0, }
      })
      setTimeout( () => {

        this.rTowers = $n.map(this.towers, (t) => {
          return t
        })
      }, 5)
    },
    formatPrice(value) {
      if (value == null || isNaN(value)) return '0'

      const num = Number(value)

      // < 1 000 000 → округляем до тысяч
      if (num < 1_000_000) {
        // 657 321 → 657к
        return `${Math.round(num / 1000)}к`
      }

      // 1 000 000 – 999 999 999 → округляем до одной десятичной
      if (num < 1_000_000_000) {
        // 1 945 000 → 1.9 млн
        return `${(num / 1_000_000).toFixed(1).replace(/\.0$/, '')} млн`
      }

      // ≥ 1 000 000 000 → округляем до одной десятичной миллиарда
      // Пример: 11.7 млрд
      return `${(num / 1_000_000_000).toFixed(1).replace(/\.0$/, '')} млрд`
    },
  },
}
</script>

<style lang="scss" scoped>
.c-towers-graph {
  background-color: #f2f4fc;
  border-radius: 16px;
  padding: 15px 40px;
  .title {
    font-weight: 700;
    margin-bottom: 10px;
    color: var(--primary);
  }
  .graph-body {
    min-width: 50px;
    display: flex;
    align-items: center;
    transition: 1s;
  }
  .towers-place {
    display: flex;
    align-items: center;
    height: 150px;
    transform: rotate(90deg);
    margin-right: 80px;
    transition: 1s;

    &.transform {
      transform: rotate(0deg);
    }
    .tower {
      margin-right: 8px;
      width: 30px;
      height: 100%;
      border-radius: 6px;
      position: relative;
      &:last-child {
        margin-right: 0;
      }
      .fill {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 100%;
        border-radius: 6px;
        transition: top 1s;
        will-change: top;
      }
      .number {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        transform: rotate(-90deg);
        font-size: 14px;
        font-weight: 700;
        white-space: nowrap;
        transition: 1s;
      }
    }
  }
  .memos {
    .memo {
      display: flex;
      align-items: center;
      .box {
        width: 16px;
        height: 16px;
        border-radius: 4px;
      }
      .title {
        font-weight: normal;
        margin-bottom: 0;
        margin-left: 10px;
        font-size: 14px;
      }
    }
  }
}
</style>
